import _ from 'lodash'
import { refreshStore } from '../../../../sweepstakes/messages'
import { config } from '../../../../components/Init/Init'
import getBannerTout from '../../../../services/content/supportedBannerTouts'
import { useCallback } from 'react'
import {
  isBannerPurchaseType,
  storeHasProduct,
  storeIsBlocked,
  storeIsInitialized,
  tokenizer
} from '../../../../services/utils'
import { usePlayerStore } from '../../../../services/store/playerStore'
import { useSetMissingBannerProducts } from '../../../../services/store/playerStore/playerActions'
import { playerProductsStoreKeys } from '../../../../services/store/playerStore/playerStoreConstants'

function _getToutForBannerEntryType(banner, action) {
  let toutObject
  switch (banner.__typename) {
    case 'banners_timerBanner_Entry':
      toutObject = getBannerTout('timer', action)
      break
    default:
      toutObject = getBannerTout(banner.alignment, action)
      break
  }

  const tout = JSON.parse(
    tokenizer(JSON.stringify(toutObject), {
      '{bgDesktop}': banner.bgImageDesktopJpg[0].url || '',
      '{bgMobileLandscape}': banner.bgImageMobileLandscapeJpg[0].url || '',
      '{bgMobile}': banner.bgImageMobilePortraitJpg[0].url || '',
      '{textColor}': banner.bannerTextColor || 'c-white',
      '{textline1}': banner.bannerTextLine1 || '',
      '{textline2}': banner.bannerTextLine2 || '',
      '{textline3}': banner.bannerTextLine3 || '',
      '{textline4}': banner.bannerTextLine4 || '',
      '{textline5}': banner.bannerTextLine5 || '',
      '{textline6}': banner.bannerTextLine6 || '',
      '{textline7}': banner.bannerTextLine7 || '',
      '{textline8}': banner.bannerTextLine8 || '',
      '{textline9}': banner.bannerTextLine9 || '',
      '{textline10}': banner.bannerTextLine10 || '',
      '{textline11}': banner.bannerTextLine11 || '',
      '{textline12}': banner.bannerTextLine12 || '',
      '{ctaText}': banner.ctaButtonText || '',
      '{ctaButtonAction}': banner.ctaButtonAction || '',
      '{ctaUrl}': banner.ctaUrl || '',
      '{deadline}': banner.deadline,
      '{timerText}': banner.timerText || '',
      '{expiredText}': banner.expiredText || '',
      '{ctaColor}': banner.bannerCtaColor || 'bgc-matt',
      '{ctaHoverColor}': `${banner.bannerCtaColor ? banner.bannerCtaColor + '-hv' : 'bgc-matt-hv'}`,
      '{bgDesktopHasWebp}': (!!(banner.bgImageDesktopWebp && banner.bgImageDesktopWebp[0])).toString(),
      '{bgMobileLandscapeHasWebp}': (!!(
        banner.bgImageMobileLandscapeWebp && banner.bgImageMobileLandscapeWebp[0]
      )).toString(),
      '{bgMobilePortraitHasWebp}': (!!(
        banner.bgImageMobilePortraitWebp && banner.bgImageMobilePortraitWebp[0]
      )).toString()
    })
  )
  // Remove CTA on missing CTA Text
  for (let i = 0; i < tout.length; i++) {
    const element = tout[i]['slot']['0']
    const content = element['content']
    if (content && content['type'] === 'link' && content['text'] === '') {
      tout.splice(i, 1)
      i--
    }
  }
  for (let i = 0; i < tout.length; i++) {
    let keys = Object.keys(tout[i].slot)
    for (const key of keys) {
      let webp = tout[i].slot[key].content.hasWebp
      if (webp === true.toString()) {
        tout[i].slot[key].content.hasWebp = true
      } else if (webp === false.toString()) {
        tout[i].slot[key].content.hasWebp = false
      }
    }
  }
  return tout
}

function _getToutV1(banner) {
  let tout = JSON.parse(banner.tout)
  if (typeof tout[0] === 'string') {
    tout = JSON.parse(tout.join(', '))
  }
  return tout
}

function _getToutV2(banner) {
  let tout
  switch (banner.__typename) {
    case 'banners_banner_Entry':
    case 'banners_timerBanner_Entry':
      tout = _getToutForBannerEntryType(banner, banner.ctaButtonAction)
      break
    case 'banners_jsonBanner_Entry':
      tout = _getToutV1(banner)
      break
    default:
      console.error('[Lobby Banner] Unknown banner type!')
  }
  return tout
}

function getTout(banner, version) {
  let tout
  if (version === 1) {
    tout = _getToutV1(banner)
  } else if (version === 2) {
    tout = _getToutV2(banner)
  }
  return tout
}

export const useParseBanners = () => {
  const playerStore = usePlayerStore()
  const playerProductsStore = playerStore.use.playerProductsStore()
  const { setMissingBannerProducts } = useSetMissingBannerProducts()

  const parseBanners = useCallback(
    (banners, bannersVersion) => {
      const parsed = []
      let reloadStore = false
      let newMissingBannerProducts = [...playerProductsStore[playerProductsStoreKeys.missingBannerProducts]]

      _.forEach(banners, banner => {
        try {
          let tout = getTout(banner, bannersVersion)
          if (isBannerPurchaseType(banner)) {
            //ignore the banner if sweeps store is blocked
            if (config.enableCryptoWallet || !storeIsInitialized() || storeIsBlocked(playerProductsStore)) {
              return
            }
            //this banner has a product to purchase
            let uuid = banner.ctaButtonAction.split('_')[1]

            if (storeHasProduct(playerProductsStore, uuid)) {
              parsed.push(tout)
            } else if (
              playerProductsStore[playerProductsStoreKeys.missingBannerProducts].findIndex(p => p === uuid) === -1
            ) {
              // If the product is not found in playerProductsStore.productsStoreData.products (zustand store), we need to refresh the store only once.
              // So store any missing product uuids in playerProductsStore.missingBannerProducts, to prevent refreshing the store multiple times.
              newMissingBannerProducts.push(uuid)
              reloadStore = true
            }
          } else {
            parsed.push(tout)
          }
        } catch {
          console.log('[Lobby] Error parsing banner... version ' + bannersVersion, banner)
        }
      })
      if (reloadStore) {
        setMissingBannerProducts(newMissingBannerProducts)

        if (config.enableSweepstakes) {
          refreshStore()
        }
      }
      return parsed
    },
    [playerProductsStore, setMissingBannerProducts]
  )

  return { parseBanners }
}
